module.exports = __webpack_public_path__ + "static/media/mileage.4dd93ccd.svg";